
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <v-row class="d-flex justify-center mt-3">
                <v-col cols="3">
                    <v-text-field
                    label="Formação"	
                    v-model="form.filters.formacao"
                    outlined
                    dense
                    ></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-autocomplete
                        v-model="form.filters.origemId"
                        label="Origem da Formação"
                        outlined
                        dense
                        :items="form.lists.origens"
                        item-text="nome"
                        item-value="id"
                    />
                </v-col>
                <sigfoco-date-picker
                    :cols="2"
                    label="Data de Solicitação"
                    v-model="form.filters.dataSolicitacao"
                    removeIcon
                    outlined
                    dense
                ></sigfoco-date-picker>
                <sigfoco-date-picker
                    :cols="2"
                    label="Data de Realização"
                    v-model="form.filters.dataRealizacao"
                    removeIcon
                    outlined
                    dense
                ></sigfoco-date-picker>
            </v-row>
            <v-row class="d-flex justify-center mt-3">
                <v-col cols="2">
                    <v-autocomplete
                        v-model="form.filters.status"
                        :items="form.lists.tiposDeStatus"
                        label="Status"
                        item-text="situacao"
                        item-value="id"
                        outlined
                        dense
                    ></v-autocomplete>
                </v-col>
                <sigfoco-date-picker
                    :cols="2"
                    label="Data Início"
                    v-model="form.filters.dataInicio"
                    removeIcon
                    outlined
                    dense
              ></sigfoco-date-picker>
              <sigfoco-date-picker
                :cols="2"
                v-model="form.filters.dataFim"
                label="Data Final"
                removeIcon
                outlined
                dense
              ></sigfoco-date-picker>
            </v-row>
             <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                text="Buscar"
                icon="mdi-magnify"
                @click="buscarRelatorios"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Limpar"
                icon="mdi-eraser"
                @click="resetForm"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5 printable"
          :headers="getFilteredHeader(headersAnalitico)"
          :items="form.lists.listRelatorios"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
          >
          <template v-slot:[`item.formacao`]="{ item }">
            {{ item.formacao }}
          </template>
          <template v-slot:[`item.origem`]="{ item }">
            {{ item.origem }}
          </template>
          <template v-slot:[`item.dataSolicitacaoStr`]="{ item }">
            {{ item.dataSolicitacaoStr }}
          </template>
          <template v-slot:[`item.dataRealizacaoStr`]="{ item }">
            {{ item.dataRealizacaoStr }}
          </template>
          <template v-slot:[`item.status`]="{ item }">
            {{ item.status }}
          </template>
          <template v-slot:[`item.dataHoraDaAcao`]="{ item }">
            {{ item.dataHoraDaAcao }}
          </template>
          <template v-slot:[`item.acao`]="{ item }">
            {{ item.acao }}
          </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorios.length"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
    import pageLoadingMixin from "mixins/page-loading.mixin";
    import RelatorioDeLog from "services/relatorios-log/manter-solicitacao-formacao.service";
    import ManterSetorService from "~/services/manter-setor.service";
    import FormacaoService from "~/services/manter-formacao.service";    
    export default {
        name: "RelatorioLogSolicitacaoFormacao",
        mixins: [pageLoadingMixin, RelatorioDeLog, ManterSetorService, FormacaoService],
    
        data: () => ({
        onReport: false,
        expanded: [],
        form: {
            filters: {
                formacao: null,
                origemId: null,
                dataSolicitacao: null,
                dataRealizacao: null,
                status: null,
                dataInicio: null,
                dataFim: null,
            },
            lists: {
                listRelatorios: [],
                origens: [],
                tiposDeStatus: []
            },
            itemsPerPage: 10,
            geradorRelatorio: null,
            horaDaGeracao: null,
            totalSolicitacaoFormacao: 0,
        },
        headersAnalitico: [
            { text: "Formação", align: "center", value: "formacao" },
            { text: "Origem da Formação", align: "center", value: "origem" },
            { text: "Data de Solicitação", align: "center", value: "dataSolicitacaoStr" },
            { text: "Data de Realização", align: "center", value: "dataRealizacaoStr" },
            { text: "Status", align: "center", value: "status" },
            { text: "Data/Hora da ação", align: "center", value: "dataHoraDaAcao" },
            { text: "Ação", align: "center", value: "acao" },
        ],
        }),
        methods: {
        getFilteredHeader(headers) {
            return headers.filter(header => {
            if (header.onlyView) return !this.onReport;
            if (header.onlyReport) return this.onReport;
            return true;
            });
        },
        async buscarRelatorios() {
            const isValid = this.validarDatas();
            if (!isValid) return;
            if (!this.verificarFiltrosPreenchidos()) return;
    
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogSolicitacaoFormacao(this.$montarParamsFilters(preparedRequest));
            this.processarRespostaRelatorio(data);
            } finally {
            this.hidePageLoading();
            }
        },
        validarDatas() {
        const { dataInicio, dataFim } = this.form.filters;
        const msgData = "A Data Início precisa ser anterior ou igual à Data Final";
        if (dataInicio && dataFim) {
          if (new Date(dataFim) < new Date(dataInicio)) {
            this.$notifyWarning(msgData);
            return false;
          }
          if (new Date(dataInicio) > new Date(dataFim)) {
            this.$notifyWarning(msgData);
            return false;
          }
        }
        return true;
      },
    
        verificarFiltrosPreenchidos() {
          const { formacao, status, origemId, dataInicio, dataFim, dataRealizacao, dataSolicitacao } = this.form.filters;
          if (!formacao && status == null && origemId == null && !dataInicio && !dataFim && !dataRealizacao && !dataSolicitacao) {
              this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
              return false;
          }
          
          return true;
        },
        async baixarCSVRelatorio() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogCSVSolicitacaoFormacao(this.$montarParamsFilters(preparedRequest));
            this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeLogDeSolicitaçãoDeFormaçãoCSV`);
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
    
        async baixarRelatorioPdf() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogPDFSolicitacaoFormacao(this.$montarParamsFilters(preparedRequest));
            const url = URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SIGFOCO.RelatórioDeLogDeSolicitaçãoDeFormação.pdf");
            document.body.appendChild(link);
            link.click();
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
        prepararRequisicao() {
            return {
            formacao: this.form.filters.formacao,
            origemId: this.form.filters.origemId,
            dataRealizacao: this.form.filters.dataRealizacao,
            dataSolicitacao: this.form.filters.dataSolicitacao,
            dataInicio: this.form.filters.dataInicio,
            dataFim: this.form.filters.dataFim,
            statusId: this.form.filters.status,
            };
        },
    
        processarRespostaRelatorio(data) {
            this.form.geradorRelatorio = data.relatorio.geradorRelatorio;
            this.form.horaDaGeracao = data.relatorio.horaDaGeracao;
            this.form.length = data.relatorio?.totalSolicitacaoFormacao;
            this.form.lists.listRelatorios = data.relatorio?.logsSolicitacoesFormacao;
        },

        resetForm() {
          this.form.filters.dataInicio = null;
          this.form.filters.dataFim = null;
    
          this.$nextTick(() => {
            this.$set(this.form.filters, 'dataInicio', null);
            this.$set(this.form.filters, 'dataFim', null);
          });
          this.form.filters.formacao = null;
          this.form.filters.origemId = null;
          this.form.filters.dataSolicitacao = null;
          this.form.filters.dataRealizacao = null;
          this.form.filters.status = null;

          this.form.lists.listRelatorios = [];
        }
    },
    mounted() {
      this.$buscarStatusFormacao().then(({ data }) => {
        this.form.lists.tiposDeStatus = data.lista;
      });
      this.$buscarOrigens().then(({ data }) => {
        this.form.lists.origens = data.itens;
      });
    }
    };
</script>
<style scoped>
.permissoes {
  padding: 1em !important;
  text-align: center;
  font-weight: 500;
}
.permissao {
  padding-right: 0.5em;
}
</style>